let validate = {
  rules: {
    c_company: {
      required: true,
      regular: /^([^\x00-\xff]|[a-z0-9\s&,+,#_\-\'\:\：\"\.·•・\(\)])+$/i,
      rangelengthENCN: [2, 200]
    },
    e_company: {
      required: true,
      rangelength: [2, 128],
      regular: /^[-0-9a-zA-Z\(\)\s,+,#\._\-\'\"\<\>&]+$/
    },
    c_name: {
      required: true,
      regular: /^([^\x00-\xff]|[a-z0-9\s&,+,#_\-\'\:\：\"\.·•・\(\)])+$/i,
      rangelength: [2, 128]
    },
    e_name: {
      required: true,
      rangelength: [2, 128],
      regular: /^[-0-9a-zA-Z\(\)\s,#\._\-\'\"\<\>&]+$/
    },
    c_country: {
      required: true
    },
    c_province: {
      requiredif: ['regionType', '1']
    },
    e_province: {
      required: true,
      rangelength: [2, 30],
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/
    },
    c_city: {
      requiredif: ['regionType', '1']
    },
    e_city: {
      required: true,
      rangelength: [2, 30],
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/
    },
    c_venu: {
      required: true,
      regular: /[\u4E00-\u9FA5]+/,
      rangelength: [4, 126]

    },
    e_venu: {
      required: true,
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/,
      rangelength: [2, 128]
    },
    postalcode: {
      required: true,
      regular: /^\w{1,15}$/
    },
    email: {
      required: true,
      rangelength: [2, 50],
      email: true
    },
    telArea: {
      required: true,
      regular: /^[0-9]{1,3}$/
    },
    telMain: {
      required: true,
      regular: /^[0-9]{6,12}$/
    },
    telExt: {
      regular: /^[0-9]{1,6}$/
    },
    mobile: {
      regular: /^[0-9]{0,20}$/
    }
  },
  messages: {
    c_company: {
      required: '请输入域名持有者名称（中文）',
      regular: '请输入域名持有者名称（中文）',
      rangelengthENCN: '单位名称为2-200个字符'
    },
    e_company: {
      required: '请输入域名持有者名称(英文)！',
      rangelength: '英文单位名称为2-128个字符',
      regular: '请填写正确单位名称英文'
    },
    c_name: {
      required: '请填写联系人姓名',
      regular: '请输入联系人姓名',
      rangelength: '联系人名称为2-128个字符'
    },
    e_name: {
      required: '请填写联系人英文姓名或填写完整拼音',
      rangelength: '联系人(英文)姓名为2-128个字符',
      regular: '请输入正确英文姓名'
    },
    c_country: {
      required: '请选择国家'
    },
    c_province: {
      requiredif: '请选择您所在的省份'
    },
    e_province: {
      required: '请填写您所在省份英文名称或完整的拼音',
      rangelength: '省份英文为2-30个字符',
      regular: '请输入正确省份英文'
    },
    c_city: {
      requiredif: '请选择城市'
    },
    e_city: {
      required: '请填写您所在城市英文名称或完整的拼音',
      rangelength: '城市英文为2-30个字符',
      regular: '请输入正确城市英文'
    },
    c_venu: {
      required: '请填写详细的通信地址（中文）',
      regular: '请输入通信地址（中文）',
      rangelength: '中文地址为2-63个汉字'
    },
    e_venu: {
      required: '请填写您的英文地址或地址的完整拼音',
      regular: '请输入正确英文地址',
      rangelength: '英文地址为2-128个字符'
    },
    postalcode: {
      required: '请填写您的邮政编码',
      regular: '请填写正确邮编'
    },
    email: {
      required: '重要，您的帐号、密码等重要信息将会发送到此邮箱。',
      rangelength: '邮箱地址为2-50个字符',
      email: '请输入正确的邮箱地址'
    },
    telArea: {
      required: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      regular: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填'
    },
    telMain: {
      required: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      regular: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填'
    },
    telExt: {
      regular: '请正确填写电话分机号'
    },
    mobile: {
      regular: '请输入0-20位电话号码'
    }
  },
  tips: {
    c_company: {
      tips: '将作为您的域名持有者，请填写与公司注册证件一致的名称，由于实名认证材料限制，请海外客户此项填写英文。'
    },
    e_company: {
      tips: '重要，如无英文公司名称请填写与中文名称相同的完整拼音'
    },
    c_name: {
      tips: '请填写联系人中文姓名'
    },
    e_name: {
      tips: '请填写联系人英文姓名或填写完整拼音'
    },
    c_country: {
      tips: '请选择国家',
      groupName: 'region'
    },
    c_province: {
      tips: '请输入省份中文',
      groupName: 'region'
    },
    e_province: {
      tips: '请填写您所在省份英文名称或完整的拼音'
    },
    c_city: {
      tips: '请选择城市',
      groupName: 'region'
    },
    e_city: {
      tips: '请填写您所在城市英文名称或完整的拼音'
    },
    c_venu: {
      tips: '请输入中文地址'
    },
    e_venu: {
      tips: '请填写您的英文地址或地址的完整拼音'
    },
    postalcode: {
      tips: '请输入邮政编码'
    },
    email: {
      tips: '请输入邮箱'
    },
    telArea: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    telMain: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    telExt: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    mobile: {
      tips: '请输入0-20位电话号码'
    }
  }

};
// 正则验证 zhanxp
jQuery.validator.addMethod('regular', function (value, element, param) {
  let reg = new RegExp(param);
  return this.optional(element) || reg.test(value);

}, '不符合指定格式！');
// 国家号码
jQuery.validator.addMethod('countryCode', function (value, element, param) {
  let str = '\'244\',\'93\',\'355\',\'213\',\'376\',\'1264\',\'1268\',\'54\',\'374\',\'247\',\'61\',\'43\',\'994\',\'1242\',\'973\',\'880\',\'1246\',\'375\',\'32\',\'501\',\'229\',\'1441\',\'591\',\'267\',\'55\',\'673\',\'359\',\'226\',\'95\',\'257\',\'237\',\'1\',\'1345\',\'236\',\'235\',\'56\',\'86\',\'57\',\'242\',\'682\',\'506\',\'53\',\'357\',\'420\',\'45\',\'253\',\'1890\',\'593\',\'20\',\'503\',\'372\',\'251\',\'679\',\'358\',\'33\',\'594\',\'241\',\'220\',\'995\',\'49\',\'233\',\'350\',\'30\',\'1809\',\'1671\',\'502\',\'224\',\'592\',\'509\',\'504\',\'852\',\'36\',\'354\',\'91\',\'62\',\'98\',\'964\',\'353\',\'972\',\'39\',\'225\',\'1876\',\'81\',\'962\',\'855\',\'327\',\'254\',\'82\',\'965\',\'331\',\'856\',\'371\',\'961\',\'266\',\'231\',\'218\',\'423\',\'370\',\'352\',\'853\',\'261\',\'265\',\'60\',\'960\',\'223\',\'356\',\'1670\',\'596\',\'230\',\'52\',\'373\',\'377\',\'976\',\'1664\',\'212\',\'258\',\'264\',\'674\',\'977\',\'599\',\'31\',\'64\',\'505\',\'227\',\'234\',\'850\',\'47\',\'968\',\'92\',\'507\',\'675\',\'595\',\'51\',\'63\',\'48\',\'689\',\'351\',\'1787\',\'974\',\'262\',\'40\',\'7\',\'1758\',\'1784\',\'684\',\'685\',\'378\',\'239\',\'966\',\'221\',\'248\',\'232\',\'65\',\'421\',\'386\',\'677\',\'252\',\'27\',\'34\',\'94\',\'1758\',\'1784\',\'249\',\'597\',\'268\',\'46\',\'41\',\'963\',\'886\',\'992\',\'255\',\'66\',\'228\',\'676\',\'1809\',\'216\',\'90\',\'993\',\'256\',\'380\',\'971\',\'44\',\'598\',\'233\',\'58\',\'84\',\'967\',\'381\',\'263\',\'243\',\'260\'';
  let reg = '\'' + value + '\'';
  return (str.search(reg) > -1);
}, '请输入86或者正确的国家区号！');

module.exports = validate;


// WEBPACK FOOTER //
// ./src/scripts/components/contactForm/rules.js